module.exports = __webpack_public_path__ + "static/media/an-kim-chi.5c48b9eb.jpeg";